import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/sagas/utilization";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import { YearOverYear } from "./smartComponents/yearOverYear";
import { FilterByClass } from "./smartComponents/filterByClass";
import { FilterByStaff } from "./smartComponents/filterByStaff";
import { DatePicker } from "./smartComponents/datePicker";
import { CustomDateRanges } from "./smartComponents/customDateRanges";
import { FilterByCategory } from "./smartComponents/filterByCategory";
import { AVERAGE_OPTIONS } from "./constants";
import { DataPoints } from "./smartComponents/dataPoints";
import { addSticky } from "../../utils/addSticky";
import KBLearnMore from "../../components/learnMore/KBLearnMore";
import NoData from "../../components/noData/noData";
import { ILEARN_URLS } from "../../constants/ilearnUrls";
import { FilterByBookingStatus } from "./smartComponents/filterByBookingStatus";
import { Averages } from "./smartComponents/averages";
import { AverageGroupFilter } from "./smartComponents/averageGroup";
import { GroupObjectsFilter } from "./smartComponents/groupObjectsFilter";
import { LocationsAverageFilter } from "./smartComponents/locationsAverageFilter";
import { FutureBookings } from "./smartComponents/FutureBookings";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { UtilizationHeatmap } from "./smartComponents/chart";

const UtilizationModule = ({ numberOfMonths, ...restProps }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.utilization.isLoading);

  const showAverages = useSelector((state) => state.utilization.showAverages);
  const average = useSelector((state) => state.utilization.average);

  const series = useSelector((state) => state.utilization.series);
  const future_bookings = useSelector((state) => state.utilization.future_bookings);

  const getData = () => {
    dispatch(
      actionCreators.fetchCurrentUser({
        currentUser: restProps,
        numberOfMonths: numberOfMonths
      })
    );
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    if (!isLoading) {
      addSticky();
    }
  }, [isLoading]);

  const averageNotSet = !average || average === AVERAGE_OPTIONS[0];
  return (
    <div className="utilization-module">
      <SectionToggle
        maxHeight="auto"
        autoHeight
        title="Class Utilization"
        customClass="class-utilization-heatmap withSticky"
        hideToggle
        isLoading={isLoading}
        learnMore={
          <KBLearnMore
            title="Class Utilization"
            description="This report shows how full your scheduled classes are by measuring attendance against class capacity. These insights help you optimize class offerings, adjust schedules, and improve overall room or instructor utilization."
            kbUrl={ILEARN_URLS.classUtilization.classUtilization}
          />
        }
        content={
          <div>
            <div className="edit-selections-bar" id="sticky-select-bar">
              <div className="selection-bar-filters">
                <div className="dates-container">
                  <div>
                    <div className="select-box-no-width">
                      <FutureBookings />
                    </div>
                  </div>
                  {future_bookings ? null : (
                    <div className="select-box-no-width date-range-select-box">
                      <p className="offers-title">Date Range</p>
                      <CustomDateRanges />
                    </div>
                  )}
                  <div className="date-select-box select-box multi" style={{ width: "287px" }}>
                    <p className="offers-title">Date</p>
                    <DatePicker />
                  </div>
                </div>
                <div></div>
                <div className="filters-container">
                  <div className="select-box" style={{ width: "200px" }}>
                    <p className="offers-title">Category</p>
                    <FilterByCategory />
                  </div>

                  <FilterByBookingStatus />

                  <Averages />

                  {averageNotSet ? null : (
                    <>
                      <AverageGroupFilter />
                      <GroupObjectsFilter />
                      <LocationsAverageFilter />
                    </>
                  )}

                  {averageNotSet ? <FilterByClass /> : null}

                  {averageNotSet && restProps.current_object_id.length <= 50 ? (
                    <FilterByStaff />
                  ) : null}

                  <UpdateBtns reset={getData} />
                </div>
              </div>
            </div>
            {series.length !== 0 || showAverages ? (
              <>
                <div className="content-wrapper">
                  <DataPoints />
                  {!showAverages ? <YearOverYear /> : null}
                </div>

                <UtilizationHeatmap />
              </>
            ) : (
              <NoData />
            )}
          </div>
        }
      />
    </div>
  );
};

export default UtilizationModule;
